<template>
  <v-app id="layout">
    <v-navigation-drawer v-if="isNotLoginPage()" v-model="drawer" app clipped color="#ea8822" dark>
      <v-list class="menu">
        <v-list-item class="menu-item" v-for="(page, i) in menu" :key="i" :to="page.route" link>
          <v-list-item-content>
            <v-list-item-title>{{page.label}}</v-list-item-title>
            <v-list-item-title class="sublabel" v-if="page.sublabel">- {{page.sublabel}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
       <v-btn href="https://portal.glintt.com" target="_blank" color="#ea8822" class="site-btn" rounded>
        <span class="material-icons">public</span>
        Ver Portal
      </v-btn>
      <v-btn color="#bb6409" class="logout-btn" rounded @click="logout()">
        <span class="material-icons">exit_to_app</span>
        Logout
      </v-btn>
    </v-navigation-drawer>

    <v-app-bar v-if="isNotLoginPage()" app clipped-left color="#ea8822" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <img class="logo" src="@/assets/images/logotipo.svg" />
      <v-btn class="user-btn" fab light large color="white" :to="'/users'">
        <v-icon color="#ea8822">mdi mdi-account</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <div class="main-content">
        <router-view></router-view>
      </div>
    </v-content>

    <v-footer app v-if="isNotLoginPage()">
      <span>&copy; 2020</span>
    </v-footer>
  </v-app>
</template>

<script>
// import { mapGetters } from 'vuex'

export default {
  name: "App",
  props: {
    source: String
  },
  data: () => ({
    items: ["Foo", "Bar", "Fizz", "Buzz"],
    drawer: null,
    menu: [
      { label: "Áreas", route: "/" },
      { label: "Categorias", route: "/categorias" },
      { label: "Familias", route: "/familias" },
      { label: "Produtos", route: "/produtos" },
      // { label: "Utilizadores", route: "/users" },
      { label: "Destaques", route: "/comunicacoes-destaque" },
      { sublabel: "Produtos", route: "/produtos-destaque" },
      { sublabel: "Novidades", route: "/novidades-destaque" },
      { sublabel: "Comunicações", route: "/comunicacoes-destaque" },
      { label: "Farmaletter", route: "/farmaletter" },
    ],
    backdoor: 0
  }),
  computed: {
    login() {
      this.backdoor;
      let logged = window.sessionStorage.getItem("loggedIn") || false;
      return logged == "true";
    }
  },
  created() {
    this.$vuetify.theme.light = true;
  },
  mounted() {
    this.prepareApp();
  },
  methods: {
    async prepareApp() {
      await this.$store.dispatch("validateState");
      this.backdoor += 1;
      this.$forceUpdate();

      if (this.login == false && this.$router.currentRoute.path != "/login") {
        this.$router.push("/login");
      }
    },
    async logout() {
      window.sessionStorage.clear();

      this.$router.push("/login");
    },
    isNotLoginPage: function() {
      return this.$router.currentRoute.path != "/login";
    }
  },
  watch: {
    $route(to) {
      this.prepareApp();
      document.title = to.meta.title || "Glintt | Backoffice";
    }
  }
};
</script>

<style lang="scss">
::-webkit-scrollbar {
  display: none;
}
html {
  -ms-overflow-style: none;
}
.v-list-item {
  min-height: auto !important;
}
#layout {
  background-color: #e8e7e3 !important;
  font-family: "Montserrat", sans-serif;
  .menu {
    padding-top: 25px;
    .menu-item {
      padding-left: 40px;
      font-weight: 400;
      text-transform: uppercase;
      margin: 10px 0;
      letter-spacing: 0px;
      font-family: "Kodchasan", sans-serif;
    }
  }
  .logo {
    width: 80px;
  }

  .user-btn {
    position: absolute;
    right: 40px;
    top: 30px;
  }
  .title-form {
    font-size: 20px !important;
    font-family: "Montserrat", sans-serif;
    font-weight: 500;
  }
  .main-content {
    padding: 80px 30px;
    .table-container {
      padding: 30px;
    }
    .section-title {
      font-family: "Kodchasan", sans-serif;
      font-weight: 600;
      color: #ea8822;
    }
    .plus-btn {
      margin-right: -18px;
      margin-top: -18px;
    }
  }
  .logout-btn{
    position: absolute;
    bottom: 40px;
    left: 40px;
    font-family: "Montserrat", sans-serif;
    font-size: 12px;
    min-width: 150px;
    span{
      margin-right: 5px;
    }
  }
  .site-btn{
    position: absolute;
    bottom: 90px;
    left: 40px;
    font-family: "Montserrat", sans-serif;
    font-size: 12px;
    min-width: 150px;
    span{
      margin-right: 5px;
    }
  }
}

.table-content {
  overflow-y: scroll;
}

td {
  white-space: nowrap;
  max-width: 100px;
  overflow: hidden;
  padding: 0 20px !important;
}

@media only screen and (max-width: 600px) {
  th {
    padding-right: 20px;
  }
  td {
    max-width: 72vw !important;
  }
}

//rewritten classes

.v-data-table__mobile-row__cell {
  padding-left: 15px;
}

.v-input--switch {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.v-dialog {
  .v-input {
    margin: 0 !important;
    padding: 0 !important;
  }
  .col {
    margin: 0 !important;
    padding: 0 !important;
  }

  .v-label {
    font-size: 12px !important;
  }
}

.logout {
  margin-bottom: 0px;
}

.sublabel {
  padding-left: 25px;
  font-size: 14px !important;
}

.v-list-item__title {
    align-self: center;
    font-size: 14px !important;
    line-height: 12px !important;
}
</style>